import { isTreeStructurePath, isTreeStructureTerminator } from "./defaultMenuStructure";
const debug = process.env.REACT_APP_DEBUG && false;
/** merges an external TDM into an existing TDM, WARN - this is not fully resolved against all possibilities  */
export const mergeExternalTreeDefinitionMapInput = ({ externalTreeDefinitionMap, treeDefinitionMap }) => {
    debug && console.log(` mergeExternalTreeDefinitionMapInput, ${!!treeDefinitionMap.Admin}`, JSON.stringify(treeDefinitionMap.Admin));
    if (externalTreeDefinitionMap) {
        Object.entries(externalTreeDefinitionMap).forEach(([externalKey, xTreeDef]) => {
            const thisTargetSection = externalKey;
            if (!treeDefinitionMap[thisTargetSection]) {
                treeDefinitionMap[thisTargetSection] = {};
            }
            const targetDef = treeDefinitionMap[thisTargetSection];
            if (!isTreeStructureTerminator(targetDef) && typeof targetDef === 'object') {
                if (!targetDef.next) {
                    if (!targetDef.treeFC) {
                        debug && console.log(`WARN targetDef has treeFC but we are adding next!`, targetDef);
                    }
                    targetDef.next = {};
                }
                if (isTreeStructurePath(targetDef)) {
                    const entries = Object.entries(targetDef.next);
                    debug && console.log(` mergeExternalTreeDefinitionMapInput, target ${thisTargetSection} is path`);
                    if (isTreeStructurePath(xTreeDef)) {
                        mergeExternalTreeDefinitionMapInput({ externalTreeDefinitionMap: xTreeDef.next, treeDefinitionMap: targetDef.next });
                    }
                    else if (isTreeStructureTerminator(xTreeDef)) {
                        debug && console.log(` mergeExternalTreeDefinitionMapInput external ${externalKey} is isTreeStructureTerminator and is destined for ${thisTargetSection}`, JSON.stringify({ xTreeDef, targetDef }));
                        targetDef.treeFC = xTreeDef.treeFC;
                        // TODO handle what will happen when incompatible external and target DEFs collide.
                        // The following is the basis for future merge improvements. It currently adds and additional unwanted duplicate layer below as externalKey is already the key being dealt with
                        // entries.push([ externalKey, { treeFC: xTreeDef.treeFC } ])
                        // // entries.splice(Math.max(targetIdx, -0), 0, ...Object.entries(xTreeDef.next).sort(([ k1, v1 ], [ k2, v2 ]) => (v1.sortOrder ?? 0) < (v2.sortOrder ?? 0) ? -1 : 1))
                        // targetDef.next = Object.fromEntries(entries)
                    }
                    else {
                        debug && console.log(` mergeExternalTreeDefinitionMapInput, unhandled type`, xTreeDef);
                    }
                }
                else {
                    debug && console.log(` mergeExternalTreeDefinitionMapInput, ${thisTargetSection} not isTreeStructurePath in original`);
                }
            }
            else {
                debug && console.log(` mergeExternalTreeDefinitionMapInput, reached treeFC`);
            }
        });
    }
    else {
        debug && console.log(` mergeExternalTreeDefinitionMapInput, no external map`);
    }
    debug && console.log(` mergeExternalTreeDefinitionMapInput, RESULT`, treeDefinitionMap);
    // Empty slot removal -- somewhat experimental as if the slots are merged later, they will have disappeared, but may be recreate ABM
    // Object.entries( treeDefinitionMap ).forEach( ( [k, v ]) => {
    //     if ( typeof v === 'object' && Object.keys( v ).length === 0 ) {
    //         delete treeDefinitionMap[k]
    //     }
    // })
    return treeDefinitionMap;
};
